module.exports = __webpack_public_path__ + "static/media/listen.c0b6c9e1.svg";